import { isSupplier } from 'permissions';

import { hasProcessPermission } from 'modules/common/permissions';

import { initCustomInterrogationDetailsPage } from './detailsPage/data/sagas';
import DetailsPage from './detailsPage/entry';
import { initCustomInterrogationListPage } from './listPage/data/sagas';
import ListPage from './listPage/entry';

export default [
  {
    exact: true,
    path: '/processes/interrogations',
    component: ListPage,
    saga: initCustomInterrogationListPage,
    permissions: [isSupplier, hasProcessPermission],
  },
  {
    exact: true,
    path: '/processes/interrogations/:customInterrogationId',
    component: DetailsPage,
    saga: initCustomInterrogationDetailsPage,
    permissions: [isSupplier, hasProcessPermission],
  },
];
